/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface RegisterCashEventDto
 */
export interface RegisterCashEventDto {
    /**
     * 
     * @type {string}
     * @memberof RegisterCashEventDto
     */
    timestamp: string;
    /**
     * 
     * @type {string}
     * @memberof RegisterCashEventDto
     */
    type: string;
    /**
     * 
     * @type {number}
     * @memberof RegisterCashEventDto
     */
    sum?: number;
    /**
     * 
     * @type {string}
     * @memberof RegisterCashEventDto
     */
    hardwareSerialNumber: string;
    /**
     * 
     * @type {string}
     * @memberof RegisterCashEventDto
     */
    paymentReference?: string;
}

/**
 * Check if a given object implements the RegisterCashEventDto interface.
 */
export function instanceOfRegisterCashEventDto(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "timestamp" in value;
    isInstance = isInstance && "type" in value;
    isInstance = isInstance && "hardwareSerialNumber" in value;

    return isInstance;
}

export function RegisterCashEventDtoFromJSON(json: any): RegisterCashEventDto {
    return RegisterCashEventDtoFromJSONTyped(json, false);
}

export function RegisterCashEventDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): RegisterCashEventDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'timestamp': json['timestamp'],
        'type': json['type'],
        'sum': !exists(json, 'sum') ? undefined : json['sum'],
        'hardwareSerialNumber': json['hardwareSerialNumber'],
        'paymentReference': !exists(json, 'paymentReference') ? undefined : json['paymentReference'],
    };
}

export function RegisterCashEventDtoToJSON(value?: RegisterCashEventDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'timestamp': value.timestamp,
        'type': value.type,
        'sum': value.sum,
        'hardwareSerialNumber': value.hardwareSerialNumber,
        'paymentReference': value.paymentReference,
    };
}

